
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SectionWrapper',
  props: {
    title: {
      type: String,
      required: true
    }
  }
})
